// Module
var code = `<div class="tercera-rename-footer">
    <terceraButton name="ok"
                   text="{{.okBtnText}}"
                   enabled="{{.enabledBtn}}"
                   terceraButtonStyle="js-button-ok"
                   on-btnClick="@this.onOKBtnClicked()" />

    <terceraButton name="cancel"
                   text="{{.cancelBtnText}}"
                   terceraButtonStyle="js-button-gray25"
                   on-btnClick="@this.onCanceBtnlClick()" />
</div>`;
// Exports
export default code;